import { EntityRepository, Repository } from "typeorm";
import { RmVehicleInspection } from "./rm-vehicle-inspection.entity";
@EntityRepository(RmVehicleInspection)
export class VehicleInspectionRepository extends Repository<RmVehicleInspection> {

}